import React, {useState} from 'react'
import {Button, Col, Form, ListGroup, Row} from "react-bootstrap"
import styles from "../styles/UserModal.module.css"
import FormSelect from "../lib/FormSelect"
import Role from "../resources/Role"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faPlus, faTimes} from "@fortawesome/free-solid-svg-icons"
import UserGroup from "../resources/UserGroup"
import ResourceTypeahead from "./ResourceTypeahead"

const UserModalRoles = ({user, roles, setRoles, canCreateManagers}) => {
  const [userGroup, setUserGroup] = useState(null)

  const addRole = () => {
    if (!userGroup) {
      return
    }
    setRoles(roles.concat({
      resource: Role.build({ user, userGroup }),
      state: {roleType: 'basic'}
    }))
    setUserGroup(null)
  }

  const handleUserGroupSelect = (userGroup) => {
    setUserGroup(userGroup)
  }

  const handleRoleChange = (ev, role) => {
    role.state[ev.target.name] = ev.target.value
    const newRoles = [...roles]
    newRoles.splice(roles.findIndex(r => r === role), 1, role)
    setRoles(newRoles)
  }

  const removeRole = (role) => {
    setRoles(roles.filter(r => r !== role))
  }

  const excludeIds = roles.map(r => r?.resource?.userGroup()?.id)

  return (
    <Form>
      <ListGroup variant="flush">
        {roles.map((role, index) => (
          <ListGroup.Item key={`role-${index}`}>
            <Row noGutters>
              <Col md={8}>
                <span className={styles.groupName}>{role.resource.userGroup().uniqueName}</span>
              </Col>
              <Col xs={3}>
                <FormSelect
                  disabled={!canCreateManagers}
                  size="sm"
                  name="roleType"
                  label=""
                  className={styles.roleTypeSelector}
                  options={Role.TYPES}
                  value={role.state.roleType}
                  onChange={(ev) => handleRoleChange(ev, role)}/>
              </Col>
              <Col xs={1}>
                {role.resource.canDestroy() &&
                <Button className="float-right"
                        variant="link-danger"
                        size="sm"
                        onClick={() => removeRole(role)}>
                  <FontAwesomeIcon icon={faTimes} />
                </Button>}
              </Col>
            </Row>
          </ListGroup.Item>
        ))}
      </ListGroup>
      <Form.Group>
        <ResourceTypeahead
          name="userGroupId"
          label=""
          placeholder="- search user group -"
          excludeIds={excludeIds}
          value={userGroup}
          onChange={handleUserGroupSelect}
          baseQuery={UserGroup.order({ name: 'asc' })}
          labelResolver={(res) => res.uniqueName}
        />
        <Button
          onClick={addRole}
          size='sm'
          variant='dark'
          disabled={user === null}
        >
          <FontAwesomeIcon icon={faPlus} />&nbsp;
          Add user group
        </Button>
      </Form.Group>
    </Form>
  )
}

export default UserModalRoles
